export default "__VITE_ASSET__BhWxyr2E__"